import { type JSX, useMemo } from 'react';
import { useEntityConfig } from '../../hooks/useEntityConfig';
import styles from './AuthWrapper.module.scss';

export const AuthWrapper = (): JSX.Element => {
  const config = useEntityConfig();
  const authUrl = useMemo(() => {
    const url = new URL(config.VITE_URL_ID_FRONTEND);
    url.searchParams.set('return_to', window.location.href);

    return url.toString();
  }, [config.VITE_URL_ID_FRONTEND]);

  return (
    <div className={styles.auth_wrapper}>
      <iframe src={authUrl} title="Authentication"></iframe>
    </div>
  );
};
